import Link from 'next/link';

export function LinkPrimaryButton({
  href,
  children,
  className,
  ...props
}: { href: string; children: React.ReactNode; className: string } & React.HTMLAttributes<HTMLAnchorElement>) {
  return (
    <Link
      href={href}
      className={`${className} inline-flex items-center rounded border border-transparent bg-blue-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
      {...props}>
      {children}
    </Link>
  );
}

export function LinkSecondaryButton({
  href,
  children,
  className,
  ...props
}: { href: string; children: React.ReactNode; className: string } & React.HTMLAttributes<HTMLAnchorElement>) {
  return (
    <Link
      href={href}
      className={`${className} inline-flex items-center rounded border border-transparent bg-green-600 px-5 py-2 text-2xl text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2`}
      {...props}>
      {children}
    </Link>
  );
}
